import Icon from "./Icon";

export default class File extends Icon {
  constructor() {
    super();
    this.d = `M 380 1 H 69 C 2 0 1 0 1 60 L 1 112 v 352 c 1 50 0 48 48 48 h 288 c 48 -1 48 -2 48 -48 z z Z z z M 330 56 L 331 100 L 49 100 L 49 56 M 51 181 L 330 181 L 330 213 L 51 213 M 52 266 L 328 265 L 329 297 L 52 297 M 53 347 L 326 347 L 327 376 L 53 376`;
  }
}
